module.exports = __webpack_public_path__ + "static/media/U.88a44ca2.png";